import Link from 'next/link';

import { styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
  padding: ${Spacing.Xs};
  width: 100%;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['3Xs']};
  width: 100%;
`;

export const FilterTriggerContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xs};
  justify-content: flex-end;
  margin-left: auto;
  padding: ${Spacing.Xs};
`;

export const IconWrapper = styled.div`
  align-items: flex-end;
  display: flex;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
  height: 100%;
  margin-left: auto;
  padding: ${Spacing.Xs};
  width: 100%;
`;

export const TrashButtonContainer = styled.div`
  display: flex;
  gap: ${Spacing.Xs};
  margin-left: auto;
  margin-top: auto;
`;

export const WorkflowOptionContainer = styled.div<{ $isReadonly: boolean }>`
  align-items: center;
  cursor: ${({ $isReadonly }) => ($isReadonly ? 'not-allowed' : 'default')};
  display: flex;
  gap: ${Spacing.Xs};
  opacity: ${({ $isReadonly }) => ($isReadonly ? 0.5 : 1)};
  pointer-events: ${({ $isReadonly }) => ($isReadonly ? 'none' : 'auto')};

  ${({ $isReadonly }) =>
    $isReadonly &&
    `
    * {
      cursor: not-allowed !important;
    }
  `}
`;

export const WorkOrderLink = styled(Link)`
  align-items: center;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: ${BorderRadius.Xxs};
  color: ${Colors.blue[100]};
  display: inline-flex;
  gap: ${Spacing['3Xs']};
  margin-top: ${Spacing.Xxs};
  padding: ${Spacing['3Xs']} ${Spacing.Xs};
  text-decoration: none;
  width: fit-content;

  &:hover {
    background-color: ${Colors.blue[5]};
    color: ${Colors.darkBlue};
  }
`;
